import SynagogueIcon from '@mui/icons-material/Synagogue';
import { ClergyList } from './ClergyList';
import { ClergyCreate } from './ClergyCreate';
import { ClergyEdit } from './ClergyEdit';

const clergy = {
  list: ClergyList,
  create: ClergyCreate,
  edit: ClergyEdit,
  icon: SynagogueIcon,
};

export default clergy;
